var _path, _ellipse, _path2, _path3, _line, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOtherDox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 40,
    height: 40,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#37d0ee",
    d: "M45.009,55H20c-2.761,0-5-2.239-5-5V12c0-2.761,2.239-5,5-5h16.423c1.65,0,3.233,0.655,4.4,1.822 l7.361,7.355c1.169,1.168,1.825,2.752,1.825,4.404V50C50.009,52.761,47.771,55,45.009,55z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.48,
    cy: 61,
    opacity: 0.3,
    rx: 19,
    ry: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15,11.947V29c2.762,0,5-2.238,5-5l0-11.525c0-0.313,0.191-0.607,0.491-0.7 C22.524,11.139,24,9.243,24,7h-4.053C17.215,7,15,9.215,15,11.947z",
    opacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.009,50.075V32c-2.762,0-5,2.238-5,5v12c0,0.552-0.448,1-1,1h-9c-2.762,0-5,2.238-5,5h15.075 C47.804,55,50.009,52.795,50.009,50.075z",
    opacity: 0.15
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 18.5,
    x2: 18.5,
    y1: 12.5,
    y2: 19.5,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#008aa9",
    d: "M48.258,16.258l-7.451-7.451C40.023,8.029,39.051,7.486,38,7.21v9.223 c0,1.419,1.15,2.569,2.569,2.569L49.798,19C49.529,17.977,49.004,17.031,48.258,16.258z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M33.5,44h-10c-0.828,0-1.5-0.672-1.5-1.5l0,0c0-0.828,0.672-1.5,1.5-1.5h10 c0.828,0,1.5,0.672,1.5,1.5l0,0C35,43.328,34.328,44,33.5,44z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M41.5,37h-18c-0.828,0-1.5-0.672-1.5-1.5l0,0c0-0.828,0.672-1.5,1.5-1.5h18 c0.828,0,1.5,0.672,1.5,1.5l0,0C43,36.328,42.328,37,41.5,37z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M41.5,30h-18c-0.828,0-1.5-0.672-1.5-1.5v0c0-0.828,0.672-1.5,1.5-1.5h18c0.828,0,1.5,0.672,1.5,1.5 v0C43,29.328,42.328,30,41.5,30z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherDox);
export default __webpack_public_path__ + "static/media/OtherDox.a3554ccbfe16df7648afa7ad2499c117.svg";
export { ForwardRef as ReactComponent };